import { INVISIBLES, stripInvisibles } from '@workspace/constants';

export const getAlignmentClass = (alignment: string | undefined): string => {
  const alignmentClean = stripInvisibles(alignment?.trim()).toLowerCase();

  if (!alignmentClean) return 'text-center';

  const alignmentMap: Record<string, string> = {
    left: 'text-left',
    right: 'text-right',
    center: 'text-center',
  };

  return alignmentMap[alignmentClean] || 'text-center';
};

export { INVISIBLES };
